import axios from "axios";
import { apiURL } from "../appRedux/actions/helpers";

export const fetchPasswordResetEligibility = async (email) => {
  try {
    const { data } = await axios.post(
      `${apiURL}/v1/user/password-reset/check`,
      { email },
      { withCredentials: true },
    );

    return data;
  } catch (error) {
    console.error("Error fetching eligibility to reset password:", error);
    throw error;
  }
};

export const trackPasswordResetAttempt = async (email) => {
  try {
    await axios.post(
      `${apiURL}/v1/user/password-reset/mark`,
      { email },
      { withCredentials: true },
    );
  } catch (error) {
    console.error("Error tracking password reset attempt:", error);
    throw error;
  }
};
